import type { FigureGroup } from "@/lib/figure-labels";

/** How a group is referred to inside a sentence, such as a control's name. */
export function namedGroup(group: FigureGroup): string {
  return group.title === "" ? "an untitled group" : group.title;
}

/**
 * How a group is headed where it is drawn as a row of its own. A heading is not a
 * sentence, hence the second spelling; both live here so they cannot drift apart.
 */
export function groupHeading(group: FigureGroup): string {
  return group.title === "" ? "Untitled group" : group.title;
}
